import { render, staticRenderFns } from "./GalleriesDesktop.vue?vue&type=template&id=1f75903c&"
import script from "./GalleriesDesktop.vue?vue&type=script&lang=js&"
export * from "./GalleriesDesktop.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesDesktop.vue?vue&type=style&index=0&id=1f75903c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports